import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";

import { withHighlightedHeadline } from "scmp-app/components/content/content-item-render/highlight/hoc";
import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import type { homeFocusContentItemContent$key } from "scmp-app/queries/__generated__/homeFocusContentItemContent.graphql";

import { Container, CoverImage, Headline, ImageContainer, StyledEntityLink } from "./styles";

export type Props = ContentItemRenderVariantProps & {
  reference: homeFocusContentItemContent$key;
};

const Component: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  onClick,
  ref,
  reference,
}) => {
  const content = useFragment(
    graphql`
      fragment homeFocusContentItemContent on Content {
        ...entityLink
        entityId
        ... on Video {
          duration
        }
        ...hooksContentItemProvidersContent
          @arguments(
            withHeadline: true
            withCoverImage: true
            withCoverImageSize640x360: true
            withCoverImageSize1280x720: true
            withVideoDurationOverlay: true
          )
      }
    `,
    reference,
  );
  const providers = useContentItemProviders(content);

  return (
    <StyledEntityLink onClick={() => onClick?.(content.entityId)} reference={content}>
      <Container className={className} ref={ref}>
        <ImageContainer>
          <CoverImage>
            {providers.coverImage({
              responsiveVariants: {
                desktopUp: "size640x360",
                mobileUp: "size1280x720",
                tabletUp: "size640x360",
              },
            })}
          </CoverImage>
          {content?.duration &&
            providers.video?.durationOverlay({
              variant: "homepage",
            })}
        </ImageContainer>
        <Headline>{providers.headline({ hideTag: true, preferSocialHeadline: true })}</Headline>
      </Container>
    </StyledEntityLink>
  );
};

Component.displayName = "ContentItemHomeFocus";

export const ContentItemHomeFocus = withHighlightedHeadline(Component);
